var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header-wrapper"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"header-content flex justify-between items-center xl:py-6 md:py-5"},[_c('Logo'),_c('Navbar')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }